import type { BaseRequest, CusRequest, ListData } from '@bluevision/tools';
import request from './base';
import { isValue, encrypt } from '@bluevision/tools';

const baseApi = '/api';

const publicKey = `-----BEGIN RSA PUBLIC KEY-----
MIIBCgKCAQEA0I7j9RrPP9tqoagcYv0UI7sWe5WBZqDrpl+Mk8mpBeVReLK9tqf6
zaHZqkp0kcPsmWqs2OAq+A18yZnuwje8xDrAp1ybUm4NdYdZxNzkQ/ovg4sEDWH3
gafzCRfmCyqdq54pqAx8aWcVsj3WtT00eMwhsjORavpl2SgaFVbtgePzt+SxuHzk
QYq0UgKLhQoyO6smh5AYTVuJYix2yz0ms+ENLwaYGBexCDs8N81y7u5xHlBcnFVj
fuhiavi0vWGPNx+t0WaJM4iHv3zdLD8m9rMvwATP/1jPKicA1YlGcJ0088zuiM08
fi9cYB+fZw9JaY+LVJmhojOMR/kBrRjdkQIDAQAB
-----END RSA PUBLIC KEY-----`;

const baseRequest: BaseRequest = (method, url, data, notice, id, addition, otherProps = {}) => {
  const { suffix } = otherProps;

  // 时间戳+随机数
  const clientFetchId = encrypt(Date.now() + Math.random().toString(16).slice(2), publicKey);

  return request(`${baseApi}/${isValue(id) ? `${url}/${id}` : url}${suffix ? `${suffix}` : ''}`, {
    method,
    data: method === 'GET' || method === 'DELETE' ? undefined : data,
    params: method === 'GET' || method === 'DELETE' ? data : undefined,
    notice,
    ...addition,
    headers: {
      'Client-Fetch-Id': !!clientFetchId ? clientFetchId : '',
    },
    // handle history type declare
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } as any);
};

export const read: CusRequest = (...r) => baseRequest('GET', ...r);

export const post: CusRequest = (...r) => baseRequest('POST', ...r);

export const put: CusRequest = (...r) => baseRequest('PUT', ...r);

export const update: CusRequest = (...r) => baseRequest('PATCH', ...r);

export const del: CusRequest = (...r) => baseRequest('DELETE', ...r);

// handle history type declare
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const download: any = async (url: string, params?: any, notice?: string, id?: string) => {
  const [res, error] = await post(url, params, notice, id, {
    getResponse: true,
    responseType: 'blob',
  });
  if (res) {
    const fileName = (res?.response?.headers?.get('Content-Disposition') || '').split('=')[1];
    const name = fileName?.replace(/"/g, '');
    try {
      const result = URL.createObjectURL(res?.data); // 创建blob地址
      const link = document.createElement('a');
      link.style.display = 'none';
      link.setAttribute('href', result);
      link.setAttribute('download', name);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      return [link, null];
    } catch (e) {
      // @ts-ignore
      return [null, e?.toString()];
    }
  }
  return [res, error];
};

// handle history type declare
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const output = (url: string) => (params?: any, signal?: AbortController['signal']) =>
  // handle history type declare
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  read<ListData<any>>(url, params, undefined, undefined, { signal });

export default request;
